import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useInfiniteQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import {
  addModelToBuyer,
  getBuyersEligibleModels,
} from 'services/BuyerModelsService';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getNextPageParam } from 'utils/getNextPageParam';

export const useGetBuyersEligibleModels = (
  perPage: number,
  companyId: number,
  buyerId: number,
  searchBy: string,
  isOpen: boolean
) =>
  useInfiniteQuery({
    queryKey: [
      ReactQueryKeys.GET_BUYERS_ELIGIBLE_MODELS,
      companyId,
      buyerId,
      perPage,
      searchBy,
    ],
    queryFn: ({ pageParam = 1 }) =>
      getBuyersEligibleModels(pageParam, perPage, searchBy, companyId, buyerId),
    getNextPageParam,
    onSuccess: (data) => {
      return data;
    },
    enabled: isOpen,
  });

export const useAddModelToBuyer = (companyId: number, buyerId: number) => {
  const { t } = useTranslation();
  return useMutation(
    (modelId: number) => addModelToBuyer(companyId, buyerId, modelId),
    {
      onSuccess: () => {
        toast.success(t('Successfully added model to buyer'));
        queryClient.invalidateQueries(ReactQueryKeys.GET_BUYER_MODELS);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error), {
          toastId: ReactMutationKeys.ADD_MODEL_TO_BUYER,
        });
      },
      mutationKey: ReactMutationKeys.ADD_MODEL_TO_BUYER,
    }
  );
};
